jQuery(document).ready(() => {
  jQuery(window).scroll(function (event) {
    let scroll = jQuery(window).scrollTop()
    if (scroll !== 0) jQuery('.header-homepage').addClass('scrolled')
    else jQuery('.header-homepage').removeClass('scrolled')
  })

  jQuery('.goto-link').on('click', function(e) {
    e.preventDefault()

    let button = jQuery(this).attr('data-goto')

    jQuery('html, body').animate({
      scrollTop: jQuery(`#${button}`).offset().top
    }, 2000)

    jQuery('body').removeClass('active')
  })

  jQuery('#open-sidebar').on('click', function () {
    jQuery('body').addClass('active')
  })

  jQuery('#overlay').on('click', function () {
    jQuery('body').removeClass('active')
  })

  jQuery('#close-sidebar').on('click', function () {
    jQuery('body').removeClass('active')
  })

  jQuery('.services-slick').slick({
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000
  })

  jQuery('.clients-slick').slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }
    ]
  })

  jQuery('#scroll-to-top').on('click', () => {
    jQuery('html, body').animate({
      scrollTop: 0
    }, 2000)
  })

  jQuery('.open-modal').on('click', (e) => {
    e.preventDefault()
    jQuery('#modal').modal({
      showClose: false
    })
  })

  jQuery('.scroll-to-contact').on('click', (e) => {
    e.preventDefault()

    jQuery('html, body').animate({
      scrollTop: jQuery(`#contact`).offset().top
    }, 2000)
  })

  jQuery('#close-modal').on('click', () => {
    jQuery.modal.close()
  })
})


